import { Alert, Divider, Grid, Typography } from '@mui/material'
import { useLoadOrderClientObservations } from 'modules/orders/hooks'
import { useFormContext } from 'react-hook-form'

export const Observations = () => {
  const { watch } = useFormContext()

  const [customer] = watch(['customer'])
  const { data: orderClientObservations } = useLoadOrderClientObservations({
    userId: customer?.id
  })
  const hasObservations = !!orderClientObservations?.data?.length

  return (
    <div style={{ height: 300, overflowX: 'auto' }}>
      {!hasObservations && <Alert severity="info">Não há dados!</Alert>}
      {orderClientObservations?.data.map((customer: any) => {
        return (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="caption" gutterBottom>
                  Observação
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                  {customer?.observation}
                </Typography>
              </Grid>
            </Grid>
            <Divider
              sx={{
                marginTop: 1,
                marginBottom: 1
              }}
            />
          </>
        )
      })}
    </div>
  )
}
